module.exports = __webpack_public_path__ + "img/tripadvisor.d4b47f7d.svg";